export const ROUTES = {
  ROOT: '/',
  CLASSIC: '/jetstreamui',
  CALLBACK: '/jetstreamui/Callback',
  BETA_ROOT: '/jetstreamui/beta',
  BETA_DOWNLOAD_PACKETS: '/jetstreamui/beta/download-packets',
} as const;

export const FEATURE_FLAGS = {
  JETSTREAM_BETA: 'JETSTREAM_BETA',
} as const;
